import React, { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import { renderFieldText, renderHiddenFieldText } from "@basecomponent";
import { classNames } from "@utilscommon";
import ImageCropper from "@imagecropper";
import LocaleStrings from "@language";
import { useLocalStorage, LOCAL_STORAGE } from "@useLocalStorage";

const FixedFields = (props) => {
  let { formValues, checkoutFormData } = props;
  const { getLocalStorage } = useLocalStorage();
  const socialDetails = getLocalStorage(LOCAL_STORAGE.USER_SOCIAL_DETAILS);
  const loginScreen = getLocalStorage(LOCAL_STORAGE.LOGIN_SCREEN);

  let profileOptionn = checkoutFormData?.data?.profileimage ?? "optional";
  // console.log("profileOptionn :- ", profileOptionn);
  let imagePreviewUrl = formValues?.profileurl ?? socialDetails?.profileurl ?? "";

  const onProfileImageSave = (img) => {
    // console.log("img :- ", img);

    props.autofill("profileurl", img === "" ? "" : img);
  };

  const expressCheckoutCompletion = () => {
    if (!_.isEmpty(loginScreen) && !_.isEmpty(socialDetails)) {
      imagePreviewUrl = socialDetails?.profileurl ?? "";
      props.autofill("profileurl", socialDetails?.profileurl ?? "");
      props.autofill("firstname", socialDetails?.firstname ?? "");
      props.autofill("lastname", socialDetails?.lastname ?? "");
      props.autofill("email", socialDetails?.email ?? "");
    }
  };

  useEffect(() => {
    if (_.isEmpty(formValues) || _.isEmpty(formValues?.name)) {
      expressCheckoutCompletion();
    }
  }, []);

  return (
    <>
      <div className="md:grid md:grid-cols-7 md:grid-flow-row md:space-x-6">
        {profileOptionn !== "hide" ? (
          <div className="col-span-2">
            <div className="space-y-1 2xs:space-y-1.5">
              <label className="control-label-top col-span-12">
                {LocaleStrings.kLabelProfilePic}

                {profileOptionn === "mandatory" ? (
                  <span className="label-mandatory">*</span>
                ) : (
                  ""
                )}
              </label>
              <ImageCropper
                displaySize={{ width: 200, height: 200 }} // For image display style
                requiredSize={{ width: 200, height: 200 }} // For image size required validation
                cropperSize={{ width: 160, height: 160 }} // Cropper display size. Note its add 50px for padding
                onImageSave={onProfileImageSave}
                imagepath={imagePreviewUrl}
                border={10}
                displayText={LocaleStrings.kFileDragDropText}
                fileSizeText={LocaleStrings.kFileMinSizeText}
                imageType="jpg"
                className=""
              />
              <Field
                name="profileurl"
                type="text"
                component={renderHiddenFieldText}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <div
          className={classNames(
            profileOptionn !== "hide" ? "col-span-5" : "col-span-7",
            "base-form"
          )}
        >
          <Field
            name="firstname"
            label={LocaleStrings.kFirstName}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
          <Field
            name="lastname"
            label={LocaleStrings.kLastName}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
          <Field
            name="email"
            label={LocaleStrings.kEmail}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    checkoutFormData: state.checkoutFormData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FixedFields);
